// extracted by mini-css-extract-plugin
module.exports = {"PlaceholderInnerContent":"LeagueMessagesPlaceholder_PlaceholderInnerContent__34zza","PlaceholderBody":"LeagueMessagesPlaceholder_PlaceholderBody__3Ili9"};